/* 🤖 this file was generated by svg-to-ts */
export const matIconWebStories: {
  name: 'web-stories';
  data: string;
} = {
  name: 'web-stories',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 4v16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-4-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h9v16zm8-14v12c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"/></svg>`
};
